import React from 'react';
import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

const spin = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
  width: 100%;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[4]};
`;

const Spinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid ${({ theme }) => theme.colors.background.secondary};
  border-top: 4px solid ${({ theme }) => theme.colors.action};
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const BounceSpinner = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[1]};
`;

const BounceDot = styled.div`
  width: 12px;
  height: 12px;
  background-color: ${({ theme, $color }) => $color || theme.colors.action};
  border-radius: 50%;
  animation: ${bounce} 1.4s ease-in-out infinite both;
  animation-delay: ${({ $delay }) => $delay}s;
`;

const LoadingText = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: ${({ theme }) => theme.typography.fontSize.lg};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  margin: 0;
`;

const LoadingSpinner = ({ 
  size = 'medium', 
  type = 'spinner', 
  text = 'Loading...',
  fullScreen = false 
}) => {
  const SpinnerComponent = () => {
    if (type === 'bounce') {
      return (
        <BounceSpinner>
          <BounceDot $color="#F3B700" $delay={0} />
          <BounceDot $color="#5C9EAD" $delay={0.16} />
          <BounceDot $color="#F57C00" $delay={0.32} />
        </BounceSpinner>
      );
    }

    return <Spinner />;
  };

  if (fullScreen) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(255, 255, 255, 0.9)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999
      }}>
        <SpinnerWrapper>
          <SpinnerComponent />
          {text && <LoadingText>{text}</LoadingText>}
        </SpinnerWrapper>
      </div>
    );
  }

  return (
    <SpinnerContainer>
      <SpinnerWrapper>
        <SpinnerComponent />
        {text && <LoadingText>{text}</LoadingText>}
      </SpinnerWrapper>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;
